export { OrganisationInfoStoreService } from './organisation-info-store.service';
